// 移动端公共页头
<template>
  <div class="headd">
    <div class="headerimg"></div>
    <div class="search"></div>
    <div class="caidan" @click="mNav"></div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      path: "",
    };
  },
  mounted() {
    this.path = this.$route.path;
  },
  methods: {
    mNav(){
      this.$router.replace("/mNav");
    }
  },
  components: {},
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style scoped lang="less">
.headd {
  font-size: 0.62rem;
  width: 100%;
  padding-top: 0.74rem;
  padding-bottom: 0.54rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  background-color: #fff;
  z-index: 1000;
  .headerimg {
    width: 12rem;
    height: 2.3rem;
    background: url("../../assets/img/icon/headernn.png") 0rem 0.3rem no-repeat;
    background-size: 100%;
    margin-left: 0.78rem;
  }
  .search {
    width: 1.2rem;
    height: 1.26rem;
    position: absolute;
    right: 2.9rem;
    top: 1.3rem;
    background: url("../../assets/img/mobile/micon/搜索(1).svg") 0rem 0rem
      no-repeat;
    background-size: 100%;
  }
  .caidan {
    width: 1.26rem;
    height: 1.26rem;
    position: absolute;
    right: 0.9rem;
    top: 1.3rem;
    background: url("../../assets/img/mobile/micon/导航.svg") 0rem 0rem
      no-repeat;
    background-size: 100%;
  }
}
</style>
